// client/src/AuthBar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { toolbarButton as buttonStyle } from './toolbarButton';

export default function AuthBar() {
  const { user, signIn, signUp, signOut } = useAuth();

  // Signed in → show Sign out, plus Admin for admins
  if (user) {
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        {user.role === 'admin' && (
          <Link
            to="/admin"
            style={{ ...buttonStyle, textDecoration: 'none', display: 'inline-block' }}
          >
            Admin
          </Link>
        )}
        <button style={buttonStyle} onClick={signOut}>
          Sign out
        </button>
      </div>
    );
  }

  // Signed out → show Sign in / Register (both open the same modal)
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <button style={buttonStyle} onClick={signIn}>
        SIGN IN
      </button>
      <button style={buttonStyle} onClick={signUp}>
        REGISTER
      </button>
    </div>
  );
}
